import React, { FC } from 'react';
import FinanceProductTabsContainer from '../PriceSection/FinanceProductTabs/FinanceProductTabsContainer';
import InformativeSectionContainer from '../PriceSection/informativeSection/InformativeSectionContainer';
import { Box, useTheme } from '@material-ui/core';
import cashFinanceGroupStyles from './cashFinanceGroupStyles';
import clsx from 'clsx';
import useIsMobile from '../../../../../common/react/useIsMobile';
import CalculateButton from '../../../presentational/financeElements/calculateButton/CalculateButton';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export interface ICashFinanceGroupProps {
  setIsFinCalcSpcModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
  isCash: boolean;
  isMultiCurrency: boolean;
  isCtaDisabled: boolean;
}

const CashFinanceGroup: FC<ICashFinanceGroupProps> = ({
  setIsFinCalcSpcModalOpen,
  isCash,
  isMultiCurrency,
  isCtaDisabled,
}) => {
  const styles = cashFinanceGroupStyles();
  const isMobile = useIsMobile();
  const onFinanceCalculate = () => setIsFinCalcSpcModalOpen(true);
  const {
    spc: {
      customise: { footer },
    },
  } = useTheme<ISpcTheme>();

  if (!isCash && (isMultiCurrency || footer?.largeAmountStyle) && isMobile) {
    return (
      <Box className={clsx(styles.container, styles.multiFinance)} data-test="customise:footer:cash_finance_group">
        <FinanceProductTabsContainer
          loading={isCtaDisabled}
          setIsFinCalcSpcModalOpen={setIsFinCalcSpcModalOpen}
          isCash={isCash}
        />
        <Box display="flex">
          <CalculateButton disabled={isCtaDisabled} onFinanceCalculate={onFinanceCalculate} />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={clsx(styles.container, { [styles.single]: !isMultiCurrency })}
      data-test="customise:footer:cash_finance_group"
    >
      <FinanceProductTabsContainer
        loading={isCtaDisabled}
        setIsFinCalcSpcModalOpen={setIsFinCalcSpcModalOpen}
        isCash={isCash}
      />
      {!isCash && <InformativeSectionContainer />}
    </Box>
  );
};

export default CashFinanceGroup;
